module.exports = __webpack_public_path__ + "img/icon-floppy.5624a74f.svg";